import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { useKpiCardSkeletonStyles } from './KpiCardSkeleton.styles';

export const KpiCardSkeleton = () => {
  const styles = useKpiCardSkeletonStyles();

  return (
    <section className={styles.root} aria-label="Loading KPI metric">
      <Skeleton aria-label="Loading">
        <SkeletonItem className={styles.label} size={12} />
        <SkeletonItem className={styles.value} size={28} />
        <SkeletonItem className={styles.trend} size={12} />
      </Skeleton>
    </section>
  );
};

KpiCardSkeleton.displayName = 'KpiCardSkeleton';
